import type { LucideProps } from 'lucide-react';
import { CircleCheck, CircleX } from 'lucide-react';

import { cn } from '@/utils';

interface Props extends LucideProps {
  success: boolean;
}

export const StatusIcon = ({ className, success, ...props }: Props) => {
  if (success) {
    return <CircleCheck className={cn('fill-success stroke-white', className)} {...props} />;
  } else {
    return <CircleX className={cn('fill-destructive stroke-white', className)} {...props} />;
  }
};
